/**
 * 根据当前域名动态生成PC URL
 * 使用 location.origin 获取当前协议和域名
 */
export const getPcUrl = (): string => {
  const origin = window.location.origin
  const host = window.location.host
  const pathname = window.location.pathname

  // 生产环境映射
  if (host === 'edu.sandstalk.com' || host === 'saas.sandstalk.com') {
    if (pathname.includes('/web/')) {
      // H5访问，跳转到PC
      return `${origin.replace('/web', '')}/#/`
    }
    return `${origin}/#/`
  }

  // UAT环境映射
  if (host === 'demo-edu.sandstalk.com' || host === 'demo.sandstalk.com' || host === 'demo-saas.sandstalk.com') {
    if (pathname.includes('/web/')) {
      // H5访问，跳转到PC
      return `${origin.replace('/web', '')}/#/`
    }
    return `${origin}/#/`
  }

  // 测试环境映射
  if (host === 'test-sands.jms.com' || host === 'sands-test-edu.jnt-express.com.cn' || host === 'sands-test-saas.jnt-express.com.cn') {
    if (pathname.includes('/web/')) {
      // H5访问，跳转到PC
      return `${origin.replace('/web', '')}/#/`
    }
    return `${origin}/#/`
  }

  if (host === 'localhost:8080') {
    if (pathname.includes('/web/')) {
      // H5访问，跳转到PC
      return 'http://localhost:3200/#/'
    }
    return 'http://localhost:3200/#/'
  }

  // 通用规则：如果当前是/web/路径，则去掉/web/跳转到PC
  if (pathname.includes('/web/')) {
    return `${origin.replace('/web', '')}/#/`
  }

  // 默认情况
  return `${origin}/#/`
}

/**
 * 根据当前域名动态生成H5 URL
 */
export const getH5Url = (): string => {
  const origin = window.location.origin
  const pathname = window.location.pathname

  // 如果当前处于 /web 或 /web/ 路径下，则保持 /web
  if (/^\/web(\/|$)/.test(pathname)) {
    return `${origin}/web/#/`
  }

  // 否则返回默认 H5 根路径
  return `${origin}/#/`
}